import type { StudentStageStatus } from '../schemas/learningPathOverview.schema';
import type { LearningPathOrdering, StudentLearningPathStatus } from '../schemas/learningPathsList.schema';
import type { StageItem, StageKey } from '../schemas/stage.schema';

export const PAGE_TITLES = {
  create: 'Criar trilha de aprendizagem',
  edit: 'Editar trilha de aprendizagem',
} as const;

// Stages are a fixed backend enum (TrilhaAprendizagemEtapaEnum); there is no endpoint listing them.
// Kept in STAGE_ORDER sequence.
export const STAGES: readonly StageItem[] = [
  {
    id: 'INTRODUCAO',
    nome: 'Introdução',
    descricao:
      'Etapa dedicada à construção de introduções contextualizadas, com teses claras e alinhadas ao tema proposto.',
  },
  {
    id: 'DESENVOLVIMENTO',
    nome: 'Desenvolvimento',
    descricao:
      'Etapa voltada ao desenvolvimento de argumentos consistentes e relacionados à tese proposta na introdução.',
  },
  {
    id: 'CONCLUSAO',
    nome: 'Conclusão',
    descricao: 'Etapa focada na elaboração de conclusões com propostas de intervenção coerentes bem estruturadas.',
  },
];

export const STAGE_DISPLAY_NAMES = Object.fromEntries(STAGES.map((stage) => [stage.id, stage.nome])) as Record<
  StageKey,
  string
>;

export const LEARNING_PATH_STATUS_LABELS: Record<StudentLearningPathStatus, string> = {
  PROGRAMADA: 'Não iniciada',
  PRODUCAO: 'Em andamento',
  CONCLUIDA: 'Concluída',
  ENCERRADA: 'Encerrada',
};

export const LEARNING_PATH_ORDERING_LABELS: Record<LearningPathOrdering, string> = {
  MAIS_RECENTES: 'Mais recentes',
  MAIS_ANTIGAS: 'Mais antigas',
  PRAZO_MAIS_PROXIMO: 'Prazo mais próximo',
  PRAZO_MAIS_DISTANTE: 'Prazo mais distante',
};

/** ENEM category ID — used as a fixed filter in the learning-path theme selection drawer. */
export const CATEGORIA_ID_ENEM = 1;

type StudentStageStatusDisplay = {
  label: string;
  variant: 'neutral' | 'information' | 'warning' | 'success' | 'error';
};

/** Label and badge color of a student's delivery status in a stage (coordinator follow-up table). */
export const STUDENT_STAGE_STATUS_DISPLAY: Record<StudentStageStatus, StudentStageStatusDisplay> = {
  NAO_INICIADA: { label: 'Não iniciada', variant: 'neutral' },
  EM_DIGITACAO: { label: 'Em digitação', variant: 'information' },
  AGUARDANDO_CORRECAO: { label: 'Aguardando correção', variant: 'warning' },
  CORRIGIDA: { label: 'Corrigida', variant: 'success' },
  CANCELADA: { label: 'Cancelada', variant: 'error' },
};
